import { Loja, Venda } from '@/models'
import { ClienteGrupoEconomico } from '@/models/GrupoEconomico'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { consultar } from '@/api/creditoInformado'

export default async function validarCreditoInformadoDoCliente(
	venda: Venda,
	loja: Loja,
	vendaModule = VendaModule,
): Promise<void> {
	if (!venda.cliente) return

	let resposta
	try {
		resposta = await consultar(venda.cliente.cnpjOuCpf, loja.id)
	} catch {
		return
	}

	if (!resposta.integracaoConfigurada) return

	// Só atualiza os campos persistidos quando a consulta respondeu com dados frescos de verdade —
	// quando consultaIndisponivel é true, bloqueado/limiteInformado/disponivelInformado são só
	// valores padrão (zerados), não o saldo real do cliente. Sobrescrever com eles zeraria o saldo
	// já persistido e faria a tela de pagamento achar que o crédito acabou sem motivo real.
	if (!resposta.consultaIndisponivel) {
		const grupos = venda.cliente.gruposEconomicos || []
		const indice = grupos.findIndex(grupo => grupo.grupoEconomico.id === loja.grupoEconomico.id)

		const grupoAtualizado: ClienteGrupoEconomico = {
			...(indice >= 0 ? grupos[indice] : {
				id: '',
				clienteId: venda.cliente.id,
				grupoEconomico: loja.grupoEconomico,
				limiteDoCrediario: 0,
				disponivelEmCrediario: 0,
			} as ClienteGrupoEconomico),
			limiteInformado: resposta.limiteInformado,
			disponivelEmLimiteInformado: resposta.disponivelInformado,
			bloqueadoCreditoInformado: resposta.bloqueado,
			motivosBloqueioCreditoInformado: resposta.motivosBloqueio.join('; '),
		}

		if (indice >= 0) {
			grupos.splice(indice, 1, grupoAtualizado)
		} else {
			grupos.push(grupoAtualizado)
		}
		venda.cliente.gruposEconomicos = grupos
	}

	if (resposta.bloqueado) {
		const motivoPadrao = `Cliente bloqueado: ${resposta.motivosBloqueio.join(', ') || 'motivo não informado'}`
		AlertModule.setError(motivoPadrao)

		const autenticacao = await vendaModule.autenticarAcaoTelaDeCaixa({
			regra: 'pode-liberar-cliente-bloqueado-por-consulta-api',
			motivoPadrao,
			regraParaAutoLiberacao: 'pode-conceder-limite-de-crediario',
		})

		if (autenticacao?.autenticado) {
			venda.liberarCrediario = true
		} else {
			AlertModule.setError('Para seguir com este cliente bloqueado é necessário autenticar. Cliente removido da venda.')
			venda.cliente = null
			venda.cpfDoCliente = ''
		}
	} else if (resposta.consultaIndisponivel) {
		const motivoPadrao = 'Consulta de crédito indisponível (plugin desativado ou rota fora do ar)'
		AlertModule.setWarning('Não foi possível confirmar o crédito do cliente agora. A consulta está indisponível.')

		const autenticacao = await vendaModule.autenticarAcaoTelaDeCaixa({
			regra: 'pode-liberar-cliente-bloqueado-por-consulta-api',
			motivoPadrao,
			regraParaAutoLiberacao: 'pode-conceder-limite-de-crediario',
		})

		if (autenticacao?.autenticado) {
			venda.liberarCrediario = true
		} else {
			AlertModule.setError('Para seguir com a consulta de crédito indisponível é necessário autenticar. Cliente removido da venda.')
			venda.cliente = null
			venda.cpfDoCliente = ''
		}
	}
}
